"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_FOR_TRAIT = void 0;
exports.TraitIcon = TraitIcon;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
function getIconUrl(iconName) {
    return `${APP_IMAGE_ROOT}/ui/${iconName}`;
}
exports.ICON_FOR_TRAIT = {
    ["fire"]: getIconUrl("traits/trait-fire.svg"),
    ["earth"]: getIconUrl("traits/trait-earth.svg"),
    ["metal"]: getIconUrl("traits/trait-metal.svg"),
    ["water"]: getIconUrl("traits/trait-water.svg"),
    ["wood"]: getIconUrl("traits/trait-wood.svg"),
    ["arcane"]: getIconUrl("traits/trait-arcane.svg"),
    ["valiant"]: getIconUrl("traits/trait-valiant.svg"),
    ["cunning"]: getIconUrl("traits/trait-cunning.svg"),
};
const useStyle = (0, react_jss_1.createUseStyles)({
    traitIcon: {
        position: "relative",
        margin: 0,
        aspectRatio: "1/1",
        containerName: "icon",
        containerType: "size",
    },
    labelContainer: {
        "position": "absolute",
        "width": "100%",
        "display": "flex",
        "flexDirection": "row",
        "justifyContent": "center",
        "fontSize": "14px",
        "bottom": "-10px",
        "@container (max-width: 31px)": {
            display: "none",
        },
        "@container (max-width: 42px)": {
            bottom: "-8px",
            fontSize: "10px",
        },
    },
    label: {
        color: "#fff",
        background: "#1d1d1d",
        padding: "2px 8px",
    },
});
function TraitIcon({ trait, className, label = false }) {
    const classes = useStyle();
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.traitIcon, className) },
        React.createElement("img", { src: exports.ICON_FOR_TRAIT[trait], alt: `${trait} trait` }),
        label && (React.createElement("div", { className: classes.labelContainer },
            React.createElement("span", { className: classes.label }, trait)))));
}
